/**
 * adminPaymentStore — Admin payment verification slice.
 *
 * Endpoint:
 *   POST /api/payments/:reference/admin-verify   body: { force?: boolean }
 */
import { API_URL } from "../../constants";
import { toDisplayString } from "../../utils/toDisplayString";
import { authHeaders, resolveToken } from "./adminUtils";

export const paymentInitialState = {
  paymentVerifyLoading: false,
  paymentVerifyError: null,
  verifiedTransaction: null,
};

export function createPaymentActions(set, get) {
  return {
    adminVerifyPayment: async (reference, { force = false } = {}) => {
      set({ paymentVerifyLoading: true, paymentVerifyError: null });
      try {
        const response = await fetch(
          `${API_URL}/api/payments/${encodeURIComponent(reference)}/admin-verify`,
          {
            method: "POST",
            headers: authHeaders(resolveToken(get)),
            body: JSON.stringify({ force: Boolean(force) }),
          }
        );

        const text = await response.text();
        let data = {};
        if (text) {
          try {
            data = JSON.parse(text);
          } catch {
            data = {};
          }
        }

        if (!response.ok || (data && data.error)) {
          throw new Error(
            toDisplayString(
              data?.error ?? data?.message,
              `Verification failed (${response.status})`
            )
          );
        }

        const transaction = data?.data ?? data ?? null;
        set({
          paymentVerifyLoading: false,
          paymentVerifyError: null,
          verifiedTransaction: transaction,
          successMessage: "Payment verified",
        });
        return { success: true, transaction };
      } catch (err) {
        const message = toDisplayString(err.message, "Failed to verify payment");
        set({ paymentVerifyLoading: false, paymentVerifyError: message });
        return { success: false, error: message };
      }
    },
  };
}

const paymentActions = createPaymentActions;
export default paymentActions;
